import * as React from "react";
const SvgFiBrandsDeezer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M24 4.161h-5.189V7.19H24zM24 8.378h-5.189v3.028H24zM24 12.594h-5.189v3.028H24zM5.189 16.811H0v3.028h5.189zM11.459 16.811H6.27v3.028h5.189zM17.73 16.811h-5.189v3.028h5.189zM24 16.811h-5.189v3.028H24zM17.73 12.594h-5.189v3.028h5.189zM11.459 12.594H6.27v3.028h5.189zM11.459 8.378H6.27v3.028h5.189z"
    />
  </svg>
);
export default SvgFiBrandsDeezer;
